import { useEffect, useState } from 'preact/hooks';
import { api, ApiError } from '../lib/api.js';
import { navigate } from '../lib/router.js';

export function LoginPage() {
  const params = new URLSearchParams(location.search);
  const inviteToken = params.get('invite') || '';
  const [mode, setMode] = useState<'login' | 'register'>(
    location.pathname === '/register' || inviteToken ? 'register' : 'login'
  );
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [notice, setNotice] = useState('');
  const [registrationOpen, setRegistrationOpen] = useState(false);

  useEffect(() => {
    void api<{ registrationOpen: boolean; me: unknown }>('/api/me').then((data) => {
      if (data.me) navigate('/');
      setRegistrationOpen(data.registrationOpen);
    });
  }, []);

  const submit = async (event: Event) => {
    event.preventDefault();
    setNotice('');
    try {
      if (mode === 'login') {
        await api('/api/auth/login', { method: 'POST', body: { login, password } });
      } else {
        await api('/api/auth/register', {
          method: 'POST',
          body: { login, password, displayName: displayName || login, inviteToken: inviteToken || undefined }
        });
      }
      navigate('/');
    } catch (error) {
      setNotice(error instanceof ApiError ? error.message : 'Ошибка сети');
    }
  };

  return (
    <main class="shell authView">
      <form class="authPanel" onSubmit={submit}>
        <p class="eyebrow">{mode === 'login' ? 'Вход' : 'Регистрация'}</p>
        <h1>Besedka</h1>
        <label>
          <span>Логин</span>
          <input type="text" value={login} onInput={(e) => setLogin(e.currentTarget.value)} required />
        </label>
        {mode === 'register' && (
          <label>
            <span>Отображаемое имя</span>
            <input type="text" value={displayName} onInput={(e) => setDisplayName(e.currentTarget.value)} />
          </label>
        )}
        <label>
          <span>Пароль</span>
          <input
            type="password"
            value={password}
            minLength={8}
            onInput={(e) => setPassword(e.currentTarget.value)}
            required
          />
        </label>
        <button class="primary" type="submit">
          {mode === 'login' ? 'Войти' : 'Зарегистрироваться'}
        </button>
        {(registrationOpen || inviteToken || mode === 'register') && (
          <button class="plain" type="button" onClick={() => setMode(mode === 'login' ? 'register' : 'login')}>
            {mode === 'login' ? 'Регистрация' : 'Уже есть аккаунт'}
          </button>
        )}
        <p class="notice">{notice}</p>
      </form>
    </main>
  );
}
